module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal doNotDesactiveOnClick"
  }, [(_vm.sharedObject) ? _c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.error) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation"
  }), _vm._v(" " + _vm._s(_vm.$t('globals.error')))])]) : (_vm.sharedObject && _vm.sharedObject.loading) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('globals.loading')))]) : [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.sharedObject && !_vm.sharedObject.loading) ? [_c('shared-object-abstract', {
    attrs: {
      "sharedObject": _vm.sharedObject,
      "role": "button"
    },
    on: {
      "click": _vm.openSharedObject
    }
  })] : _vm._e()], 2), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.sharedObject) ? [(_vm.sharedObject.permissions && !_vm.sharedObject.permissions.EDIT) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.$t('sharedObjectMembers.noSuffisantRight')))]) : _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.$t('sharedObjectMembers.suffisantRight')) + " ")]), (_vm.viewersStatus == _vm.STATUS.LOADING) ? [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('globals.loading')))] : [_vm._l((_vm.restrictedViewers), function(viewer) {
    return [_c('div', {
      key: viewer.id,
      staticClass: "viewer",
      class: {
        restricted: viewer.permissions.restricted, canNotView: !viewer.permissions.canView
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleViewer(viewer)
        }
      }
    }, [_c('vue-object-img', {
      attrs: {
        "object": viewer
      }
    }), _vm._v(" " + _vm._s(viewer.name)), (viewer.permissions.restricted && !viewer.permissions.canView) ? _c('i', {
      staticClass: "fa fa-eye-slash action"
    }) : _vm._e(), (viewer.permissions.restricted && viewer.permissions.canView) ? _c('i', {
      staticClass: "fa fa-eye action"
    }) : _vm._e()], 1)]
  }), (_vm.sharedObject.permissions && _vm.sharedObject.permissions.EDIT) ? _c('auto-complete-user', {
    ref: "autoCompleteUser",
    staticClass: "doNotDesactiveOnClick",
    attrs: {
      "showGroops": "none",
      "showUsers": "all",
      "placeholder": "Entrez le nom ou l'email d'une personne pour l'ajouter",
      "acceptNewUser": true,
      "acceptNewGroop": false,
      "container": _vm.$refs.modal.getElementsByClassName("modal-body")[0]
    },
    on: {
      "select": _vm.addRestrictedUser
    }
  }) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleShowNonRestricted
    }
  }, [_vm._v(_vm._s(_vm.$tc('sharedObjectMembers.otherViewers', _vm.nonRestrictedViewers.length, {
    nb: _vm.nonRestrictedViewers.length
  })))])]), (_vm.showNonRestricted) ? [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.$t('sharedObjectMembers.otherViewersDescription')))]), (_vm.viewersStatus == _vm.STATUS.LOADING) ? [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('globals.loading')))] : _vm._e(), _vm._l((_vm.nonRestrictedViewers), function(viewer) {
    return [_c('div', {
      key: viewer.id,
      staticClass: "viewer"
    }, [_c('vue-object-img', {
      attrs: {
        "object": viewer
      }
    }), _vm._v(" " + _vm._s(viewer.name))], 1)]
  })] : _vm._e()]] : _vm._e()], 2)]], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3dbde4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SharedObjectMembers/SharedObjectMembers.vue
// module id = 1276
// module chunks = 1